import { render, staticRenderFns } from "./extras.vue?vue&type=template&id=5bfe332c&scoped=true&"
import script from "./extras.vue?vue&type=script&lang=js&"
export * from "./extras.vue?vue&type=script&lang=js&"
import style0 from "./extras.vue?vue&type=style&index=0&id=5bfe332c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe332c",
  null
  
)

export default component.exports